import { createFileRoute, Link } from "@tanstack/react-router";
import { Section } from "@/components/landing/Section";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import {
  termsBreadcrumbJsonLd,
  termsJsonLd,
  termsRouteHead,
} from "@/lib/terms-seo";
import { renderTermsOfServiceHtml } from "@/lib/terms-of-service";

// Built exactly like `/privacy`: head/meta and structured data from
// `src/lib/terms-seo.ts`, the rendered body from `src/lib/terms-of-service.ts`,
// referenced from the component only so markdown-it and the terms text stay in
// this route's chunk. Under `_home` for the site header and footer.
export const Route = createFileRoute("/_home/terms")({
  ssr: true, // public SEO route (D-216-5); the connector directories fetch it
  head: termsRouteHead,
  component: TermsPage,
});

function TermsPage() {
  // Memoised inside `terms-of-service.ts`; the source is a static file.
  const termsHtml = renderTermsOfServiceHtml();
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(termsJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(termsBreadcrumbJsonLd) }}
      />
      <nav aria-label="Breadcrumb" className="sr-only">
        <ol>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-current="page">Terms</li>
        </ol>
      </nav>
      <main>
        <Section>
          <article
            className="gs-reading"
            dangerouslySetInnerHTML={{ __html: termsHtml }}
          />
        </Section>
      </main>
    </>
  );
}
